"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeEngineLogger = void 0;
__exportStar(require("./Settings"), exports);
__exportStar(require("./socket"), exports);
__exportStar(require("./core"), exports);
__exportStar(require("./core/vfx/LocationSelector"), exports);
__exportStar(require("./core/vfx/Step"), exports);
__exportStar(require("./core/vfx/core"), exports);
__exportStar(require("./core/Duration"), exports);
__exportStar(require("./core/enums"), exports);
__exportStar(require("./core/Id"), exports);
__exportStar(require("./core/Schedule"), exports);
__exportStar(require("./core/Target"), exports);
__exportStar(require("./core/abilities/AbilityArgs"), exports);
__exportStar(require("./core/abilities/AbilityState"), exports);
__exportStar(require("./core/abilities/AbilityType"), exports);
__exportStar(require("./core/actions/ActionArgs"), exports);
__exportStar(require("./core/actions/ActionState"), exports);
__exportStar(require("./core/actions/ActionType"), exports);
__exportStar(require("./core/actions/core"), exports);
__exportStar(require("./core/actors/ActorAbilityState"), exports);
__exportStar(require("./core/actors/ActorArgs"), exports);
__exportStar(require("./core/actors/ActorState"), exports);
__exportStar(require("./core/actors/ActorType"), exports);
__exportStar(require("./core/adventures/AdventureState"), exports);
__exportStar(require("./core/effects/EffectArgs"), exports);
__exportStar(require("./core/effects/EffectState"), exports);
__exportStar(require("./core/effects/EffectType"), exports);
__exportStar(require("./core/effects/core"), exports);
__exportStar(require("./core/event-handlers/BoundEventHandlerScript"), exports);
__exportStar(require("./core/event-handlers/EventHandlerArgs"), exports);
__exportStar(require("./core/event-handlers/EventHandlerState"), exports);
__exportStar(require("./core/event-handlers/EventHandlerType"), exports);
__exportStar(require("./core/event-handlers/core"), exports);
__exportStar(require("./core/events/EventArgs"), exports);
__exportStar(require("./core/events/EventArgsInstance"), exports);
__exportStar(require("./core/events/EventState"), exports);
__exportStar(require("./core/events/EventType"), exports);
__exportStar(require("./core/events/core"), exports);
__exportStar(require("./core/rooms/RoomArgs"), exports);
__exportStar(require("./core/rooms/RoomScript"), exports);
__exportStar(require("./core/rooms/RoomState"), exports);
__exportStar(require("./core/rooms/RoomType"), exports);
__exportStar(require("./core/rooms/core"), exports);
__exportStar(require("./core/equipment/EquipmentArgs"), exports);
__exportStar(require("./core/equipment/EquipmentState"), exports);
__exportStar(require("./core/items/Item"), exports);
__exportStar(require("./core/maps"), exports);
__exportStar(require("./core/utils/ApplyAttribute"), exports);
__exportStar(require("./core/utils/Round"), exports);
__exportStar(require("./core/vfx/LocationSelector"), exports);
__exportStar(require("./core/vfx/Step"), exports);
__exportStar(require("./core/vfx/Text"), exports);
__exportStar(require("./core/vfx/TimeInterval"), exports);
__exportStar(require("./core/vfx/core"), exports);
__exportStar(require("./core/state/Registries"), exports);
__exportStar(require("./eternity/ai"), exports);
__exportStar(require("./eternity/abilities"), exports);
__exportStar(require("./eternity/adventures"), exports);
__exportStar(require("./eternity/event-handler-scripts"), exports);
__exportStar(require("./engine"), exports);
__exportStar(require("./utils/Array"), exports);
__exportStar(require("./utils/SmartRegistry"), exports);
__exportStar(require("./utils/AutoRegistry"), exports);
__exportStar(require("./utils/Copy"), exports);
__exportStar(require("./utils/Enumerable"), exports);
__exportStar(require("./utils/Map"), exports);
__exportStar(require("./utils/Mem2"), exports);
__exportStar(require("./utils/NameOf"), exports);
__exportStar(require("./utils/Random"), exports);
__exportStar(require("./utils/Record"), exports);
__exportStar(require("./utils/Enum"), exports);
__exportStar(require("./utils/Flatten"), exports);
require("./core/state-extensions/Permanents");
__exportStar(require("./metadata/AbilityMetas"), exports);
__exportStar(require("./metadata/Attributes"), exports);
__exportStar(require("./metadata/ItemTypes"), exports);
__exportStar(require("./metadata/Effects"), exports);
var Logger_1 = require("./Logger");
Object.defineProperty(exports, "changeEngineLogger", { enumerable: true, get: function () { return Logger_1.changeEngineLogger; } });
